import { UnitFields } from "type/dl_unit/dl_unit.type";
import { axiosCitajteo } from "../../axios/citajteo_axios";

export type UnitAddParams = {
  slug: string;
  uType: string;
  num: number;
  fold: string;
  scans: string[];
  fVals: Record<string, string>;
  pdf: any;
};

export type UnitUpdateParams = Partial<UnitAddParams>;

export const unitAdd = async (
  addParams: UnitAddParams,
): Promise<string | null> => {
  let result: string | null = null;
  let response: any;

  try {
    response = await axiosCitajteo.post("dl-unit", addParams);
  } catch (error) {
    console.log("unitAdd - error", error);
  }

  if (response && response.status === 201) {
    result = response.data;
  }

  return result;
};

export const unitUpdate = async (
  id: string,
  updatePayload: UnitUpdateParams,
): Promise<boolean> => {
  let result = false;
  let response: any;

  try {
    response = await axiosCitajteo.put(`dl-unit/${id}`, updatePayload);
  } catch (error) {
    console.log("unitUpdate - error", error);
  }

  if (response && response.status === 204) {
    result = true;
  }

  return result;
};

export const unitDelete = async (id: string): Promise<boolean> => {
  let result = false;
  let response: any;

  try {
    response = await axiosCitajteo.delete(`dl-unit/${id}`);
  } catch (error) {
    console.log("unitDelete - error", error);
  }

  if (response && response.status === 204) {
    result = true;
  }

  return result;
};

export const unitsFieldsAdd = async (fields: UnitFields[]): Promise<string> => {
  let result = "";
  let response: any;

  try {
    response = await axiosCitajteo.post("dl-unit/units-fields", { fields });
  } catch (error) {
    console.log("unitsFieldsAdd - error", error);
  }

  if (response && response.status === 200) {
    result = response.data;
  }

  return result;
};

export const unitPdfUpdate = async (
  unitId: string,
  fileName: string,
): Promise<boolean> => {
  let result = false;
  let response: any;

  try {
    response = await axiosCitajteo.put(`dl-unit/${unitId}/pdf`, { fileName });
  } catch (error) {
    console.log("unitPdfUpdate - error", error);
  }

  if (response && response.status === 204) {
    result = true;
  }

  return result;
};

export const unitScanUpdate = async (
  unitId: string,
  fileNames: string[],
): Promise<boolean> => {
  let result = false;
  let response: any;

  try {
    response = await axiosCitajteo.put(`dl-unit/${unitId}/scan`, { fileNames });
  } catch (error) {
    console.log("unitScanUpdate - error", error);
  }

  if (response && response.status === 204) {
    result = true;
  }

  return result;
};
